import { render, staticRenderFns } from "./DeliveryNotice.vue?vue&type=template&id=bc64e474&"
import script from "./DeliveryNotice.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports